import { applyNodeChanges } from '@xyflow/react';
import { useCallback } from 'react';

import { FamilyTreeNode } from '@/components/diagrams/FlowChart';

import { FamilyTreeActionFn, NodesChangedAction } from '../types';

export function useNodesChangedAction() {
  return useCallback<FamilyTreeActionFn<NodesChangedAction>>(
    (state, { changes }, _queueEffect) => {
      const nextNodes = applyNodeChanges<FamilyTreeNode>(changes, state.nodes);

      const hasPositionChange = changes.some(
        (change) => change.type === 'position' && change.position !== undefined
      );

      // Keep local positions even when a drag also changes node dimensions.
      if (hasPositionChange) {
        const updatedNodePositions = nextNodes.map((node) => ({
          nodeID: node.id,
          xPosition: node.position.x,
          yPosition: node.position.y,
        }));

        return {
          ...state,
          nodes: nextNodes,
          nodePositions: updatedNodePositions,
          hasUnsavedNodePositions: true,
        };
      }

      return { ...state, nodes: nextNodes };
    },
    []
  );
}
